export default __webpack_public_path__ + "static/3-07872a0c50dd95923231f928328c3988.jpg";